import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

export async function fetchReview(params) {
  return await request({
    url: ENDPOINT.HOME_REVIEW,
    method: "get",
    params,
  });
}

export async function fetchReviewById(id) {
  return await request({
    url: `${ENDPOINT.HOME_REVIEW}/${id}/edit`,
    method: "get",
  });
}

export async function createReview(data) {
  return await request({
    url: ENDPOINT.HOME_REVIEW,
    method: "post",
    data,
  });
}

export async function updateReview(id, data) {
  return await request({
    url: `${ENDPOINT.HOME_REVIEW}/${id}`,
    method: "post",
    data,
  });
}

export async function deleteReview(id, data) {
  return await request({
    url: `${ENDPOINT.HOME_REVIEW}/${id}`,
    method: "post",
    data
  });
}